import React from 'react';
import { Box, Flex, Heading, Text, Image, keyframes } from '@chakra-ui/react';

const waveAnimation = keyframes`
  0% { transform: translateX(0); }
  50% { transform: translateX(-50px); }
  100% { transform: translateX(0); }
`;

const fadeInUp = keyframes`
  0% {
    opacity: 0;
    transform: translateY(100px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Hero = () => {
  return (
    <Box
      w="100%"
      height={{ base: '100vh', md: '100vh' }}
      bg="#222"
      bgImage="url('/bg.jpg')"
      bgSize="cover"
      bgPosition="center"
      position="relative"
      color="white"
      overflow="hidden"
    >
      <Flex
        h="100%"
        mt={{ base: '5rem', md: '0px' }}
        alignItems="center"
        justifyContent={{ base: 'center', md: 'space-between' }} 
        px="10%"
        position="relative"
        direction={{ base: 'column', md: 'row' }}
      >
        <Box maxW="600px" zIndex="1" textAlign={{ base: 'center', md: 'left' }} mb={{ base: '4', md: '0' }}>
          <Heading
            as="h1"
            fontSize={{ base: '4rem', md: '130px' }}
            lineHeight="85%"
            textTransform="uppercase"
            fontFamily="'Fugaz One', sans-serif"
            letterSpacing="-3px"
            marginTop="0px"
          >
            SAINT<br />SEIYA
          </Heading>
          <Text fontSize={{ base: '0.9rem', md: '1rem' }} mt="4" mb="4" lineHeight="1.4" fontFamily="'Inter', sans-serif" maxW="450px">
            Join the Saint Seiya on the SEI chain!.<br/>No matter how many times I fall, I will always stand up!
          </Text>
          <Box
            mt="0"
            w="75%"
            h="3px"
            bg="red"
            position="relative"
            mx={{ base: 'auto', md: '0' }}
          />
        </Box>

        <Image
          src="/render.png"
          alt="Seia"
          width={{ base: '600px', md: '900px' }}
          position="relative"
          top={{ base: '35px', md: '95px' }}

          left={{ base: '0', md: '50px' }}
          filter="drop-shadow(5px 5px 0px red) saturate(150%)"
          zIndex="2"
          mx={{ base: 'auto', md: '0' }}
          animation={`${fadeInUp} 2s ease-out`}
        />
      </Flex>

      <Box
        position="relative"
        left="0"
        w="100%"
        h="auto"
      >
        <svg
          viewBox="0 0 1440 320"
          xmlns="http://www.w3.org/2000/svg"
          style={{ position: 'absolute', bottom: '0', width: '100%' }}
        >
          <path
            fill="#ff0000"
            d="M0,224L80,218.7C160,213,320,203,480,213.3C640,224,800,256,960,245.3C1120,235,1280,181,1360,154.7L1440,128L1440,320L1360,320C1280,320,1120,320,960,320C800,320,640,320,480,320C320,320,160,320,80,320L0,320Z"
            style={{
              animation: `${waveAnimation} 8s infinite ease-in-out`,
            }}
          />
        </svg>
      </Box>
    </Box>
  );
};

export default Hero;
